<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16">
  <g [attr.fill]="color" transform="translate(5) rotate(30.000000)">
    <path d="M5.4 5.6C6.7 6.1 7.7 7.5 7.7 9L7.7 9.3 5 9.3 4 16.7C3.3 11.8 3 9.3 3 9.3L0.3 9.3 0.3 9C0.3 7.5 1.3 6.1 2.6 5.6L1.7 0.7 6.3 0.7 5.4 5.6Z"/>
  </g>
</svg>
